var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccreditationVerified({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.384,
    height: 23.521,
    viewBox: "0 0 21.384 23.521",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8156",
    "data-name": "Rectangle 8156",
    width: 21.384,
    height: 23.521,
    fill: "#3acb27"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15574",
    "data-name": "Group 15574",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15573",
    "data-name": "Group 15573",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5374",
    "data-name": "Path 5374",
    d: "M18.872,1.741,11.387.073a3.382,3.382,0,0,0-1.39,0L2.513,1.741A3.208,3.208,0,0,0,0,4.873V9.225A15.043,15.043,0,0,0,9.548,23.3a3,3,0,0,0,1.144.225,3.217,3.217,0,0,0,1.144-.214A15.077,15.077,0,0,0,21.384,9.225V4.873a3.208,3.208,0,0,0-2.513-3.133m-3.1,7.623-5.143,5.057a1.069,1.069,0,0,1-1.508,0l-2.438-2.4a1.069,1.069,0,0,1-.006-1.512l.006-.006a1.069,1.069,0,0,1,1.508,0L9.88,12.165l4.394-4.277a1.074,1.074,0,1,1,1.508,1.529Z",
    transform: "translate(0 0)",
    fill: "#3acb27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccreditationVerified);
export default __webpack_public_path__ + "static/media/accreditation-verified.7ff438264f9a6f0ae3ed31624e9d024e.svg";
export { ForwardRef as ReactComponent };